<template>
  <div class="page-nav">
    <div class="mobile-main">
      <div class="nav-box">
        <router-link to="/" class="logo"></router-link>
        <div class="links">
          <router-link to="/record-depot" active-class="cur">唱片</router-link>
          <router-link to="/song-depot" active-class="cur">曲目</router-link>
          <span
            :class="showMobileSlideNav ? 'hover-nav cur' : 'hover-nav'"
            @click="showMobileSlideNav = !showMobileSlideNav"
            >{{ showMobileSlideNavCurrent }}</span
          >
          <span
            :class="showMobileSlideUser ? 'hover-user cur' : 'hover-user'"
            @click="showMobileSlideUser = !showMobileSlideUser"
          ></span>
        </div>
        <div v-if="showMobileSlideNav" class="slide-box-nav">
          <router-link to="/musician-depot" active-class="cur"
            >乐人</router-link
          >
          <router-link to="/company-depot" active-class="cur">机构</router-link>
        </div>
        <div v-if="showMobileSlideUser" class="slide-box-user">
          <template v-if="isLogin">
            <div class="user-menu">
              <router-link to="/fav/record" class="lg">
                <i class="fav"></i>我的收藏
              </router-link>
              <router-link to="/fav/record">
                <i class="record"></i>唱片
              </router-link>
              <router-link to="/fav/song">
                <i class="song"></i>曲目
              </router-link>
              <router-link to="/fav/mc">
                <i class="singer"></i>乐人
              </router-link>
              <router-link to="/fav/org">
                <i class="org"></i>机构团体
              </router-link>
            </div>
            <div class="user-menu" v-if="userInfo.roleId">
                <a href="javascript:" @click="openFeedBack" >
                  <a-icon type="form" :style="{ fontSize: '17px', color:'#cb5554' }"/>信息反馈
                </a>
              </div>
            <div class="logout-menu">
              <a href="javascript:" @click="loginout">
                <i class="logout"></i>退出账号
              </a>
            </div>
          </template>
          <template v-else>
            <div class="user-menu">
              <a :href="loginHref"> <i class="login"></i>登录 </a>
              <!-- <a href="http://beta.library.sh.cn/SHLibrary/register.html"> -->
              <a :href="registerUrl">
                <i class="sign"></i>注册
              </a>
            </div>
          </template>
        </div>
      </div>
      <!-- <div v-if="showMobileSearch" class="mobile-top-search"> -->
           <div class="mobile-top-search">
        <div :class="searchHover ? 'ipt hv' : 'ipt'">
          <input
            type="text"
            placeholder="搜索唱片、曲目、乐人、机构团体等关键词"
            v-model="keyword"
            @focus="hoverHandle"
            @keyup="changeHandle"
            @blur="blurHandle"
          />
          <a href="javascript:" class="search-btn" @click="goSearch"></a>
          <a
            href="javascript:"
            v-if="showSearchHelp"
            class="cls"
            @click="clearKeyWord"
          ></a>
        </div>
      </div>
    </div>
    <div class="main-box">
      <div class="nav-left">
        <router-link to="/" class="logo"></router-link>
        <div class="links">
          <router-link to="/" exact-active-class="cur">首页</router-link>
          <router-link to="/record-depot" active-class="cur">唱片</router-link>
          <router-link to="/song-depot" active-class="cur">曲目</router-link>
          <router-link to="/musician-depot" active-class="cur"
            >乐人</router-link
          >
          <router-link to="/company-depot" active-class="cur"
            >机构团体</router-link
          >
        </div>
      </div>
      <div class="nav-right">
        <div class="search-box">
          <div :class="searchHover ? 'search-ipt hv' : 'search-ipt'">
            <input
              type="text"
              placeholder="搜索唱片、曲目、乐人、机构团体等关键词"
              v-model="keyword"
              @focus="hoverHandle"
              @keyup="changeHandle"
              @blur="blurHandle"
              @keyup.enter="goSearch"
            />
            <a href="javascript:" class="icon" @click="goSearch"></a>
            <a
              href="javascript:"
              v-if="showSearchHelp"
              class="cls"
              @click="clearKeyWord"
            ></a>
          </div>
          <a
            href="javascript:"
            :class="hasAdvance ? 'more-search cur' : 'more-search'"
            @click="advanced"
            >高级<br />检索</a
          >
        </div>
        <div class="user-info">
          <span
            v-if="isLogin"
            class="base-pic-placeholder bg4"
            @mouseenter="showUserMenu = true"
          >
            {{ userInfo.firstName }}
          </span>
          <span
            v-else
            class="login-user"
            @mouseenter="showUserMenu = true"
          ></span>
          <!-- <span :class="isLogin?'user':'login-user'" @mouseenter="showUserMenu=true"></span> -->
          <div
            v-if="showUserMenu"
            :class="isLogin ? 'user-hover' : 'user-hover sm'"
            @mouseleave="showUserMenu = false"
          >
            <template v-if="isLogin">
              <div class="user-menu">
                <router-link to="/fav/record" class="lg">
                  <i class="fav"></i>我的收藏
                </router-link>
                <router-link to="/fav/record">
                  <i class="record"></i>唱片
                </router-link>
                <router-link to="/fav/song">
                  <i class="song"></i>曲目
                </router-link>
                <router-link to="/fav/mc">
                  <i class="singer"></i>乐人
                </router-link>
                <router-link to="/fav/org">
                  <i class="org"></i>机构团体
                </router-link>
              </div>
               <div class="logout-menu" v-if="userInfo.roleId">
                <a href="javascript:" @click="openFeedBack" >
                  <a-icon type="form" :style="{ fontSize: '17px',color:'#cb5554' }"/>信息反馈
                </a>
              </div>
            <!-- 管理员能进入后台系统 -->
              <div class="logout-menu" v-if="userInfo.roleId>2">
                <a href="javascript:" @click="adminLogin">
                  <i class="login"></i>后台管理
                </a>
              </div>
              <div class="logout-menu">
                <a href="javascript:" @click="loginout1">
                  <i class="logout"></i>退出账号
                </a>
              </div>
            </template>
            <template v-else>
              <div class="user-menu">
                <a :href="loginHref"> <i class="login"></i>登录 </a>
                <!-- <a href="http://beta.library.sh.cn/SHLibrary/register.html"> -->
                <a :href="registerUrl">
                  <i class="sign"></i>注册
                </a>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
    <div :class="showSearchHelp ? 'search-help hv' : 'search-help'">
      <div  v-if="this.yrList.length>0" class="h-b">
        <div class="lb">
          乐人
          <span @click="moreClick('searchMusician')" class="all-result"
            >更多<i></i
          ></span>
        </div>
        <div class="pp">
          <router-link
            :to="'/musician-detail/' + encodeURIComponent(item['@id'])"
            class="musician-p"
            v-for="(item, index) in yrList"
            :key="index"
          >
            <div class="ava" v-if="item.name && item.name['@value']">
              <img v-if="item.img" :src="item.img" alt="" />
              <div
                v-else
                :class="'base-pic-placeholder bg' + parseInt(Math.random() * 6)"
              >
                {{ item.name["@value"].substring(0, 1) }}
              </div>
            </div>
            <p>{{ item["name"]["@value"].replace('~','').replace('=','').replace(':','').replace(/[||]/g,'#').replace(/##/g,'') }}</p>
          </router-link>
        </div>
      </div>
      <div  v-if="this.cpList.length>0" class="h-b">
        <div class="lb">
          唱片
          <span @click="moreClick('searchRecord')" class="all-result"
            >更多<i></i
          ></span>
        </div>
        <div class="t-h" v-for="(item, index) in cpList" :key="index">
          <router-link :to="'/rec-info/' + encodeURIComponent(item['@id'])"
            ><i class="rcd"></i>{{ item["title"].replace('~','').replace('=','').replace(':','').replace(/[||]/g,'#').replace(/##/g,'') }}</router-link
          >
        </div>
      </div>
      <div  v-if="this.qmList.length>0" class="h-b">
        <div class="lb">
          曲目
          <span @click="moreClick('searchSong')" class="all-result"
            >更多<i></i
          ></span>
        </div>
        <div class="t-h" v-for="(item, index) in qmList" :key="index">
          <router-link :to="'/song-detail/' + encodeURIComponent(item['@id'])"
            ><i class="song"></i>{{ item["title"].replace('~','').replace('=','').replace(':','').replace(/[||]/g,'#').replace(/##/g,'') }}</router-link
          >
        </div>
      </div>
      <div v-if="this.jgList.length>0"  class="h-b">
        <div class="lb">
          机构团体
          <span @click="moreClick('searchCompany')" class="all-result"
            >更多<i></i
          ></span>
        </div>
        <div class="t-h" v-for="(item, index) in jgList" :key="index">
          <router-link
            :to="'/company-detail/' + encodeURIComponent(item['@id'])"
            ><i class="jg"></i>{{ item.nameChs.replace('~','').replace('=','').replace(':','').replace(/[||]/g,'#').replace(/##/g,'') }}</router-link
          >
        </div>
      </div>
    </div>
    <a-modal
      title="信息反馈"
      :visible="feedBackVisible"
      :footer="null"
      @cancel="closeFeedBack"
    >
     <div class="ipt-box">
          <div  class="ipt">
             <span class="lb"><label for="feedTitle" title="feedTitle" class="ant-form-item-required">反馈标题：</label></span>
            <a-input :max-length="50"   @input="descInput(1)"  placeholder="请输入反馈标题（不少于5个字符）" v-model="feedTitle" v-decorator="['feedTitle',  { rules: [{ required: true, message: '请输入反馈标题', trigger: 'blur' }] }]" />
             <span class="inputNum1" >{{txtTitleVal}}/50</span>
          </div>

           <div  class="ipt">
              <span class="lb"><label for="feedContent" title="feedContent" class="ant-form-item-required">反馈内容：</label></span>
            <a-textarea
            placeholder="请输入反馈内容（不少于10个字符）" @input="descInput(2)" v-model="feedContent"
            :auto-size="{ minRows: 5, maxRows: 10 }" :max-length="300" v-decorator="['feedTitle', { rules: [{ required: true, message: '请输入反馈内容' }] }]"
          />
          <span class="inputNum2" >{{txtContentVal}}/300</span>
          </div>
            <!-- <div  class="ipt">
             <span class="lb">联系方式：</span>
           <a-input v-model="feedPhone" :max-length="25"  placeholder="请输入联系方式" />
          </div> -->
        </div>

      <div class="modal-btn">
        <a href="javascript:" class="cancel" @click="closeFeedBack">取消</a>
        <a href="javascript:" class="confirm" @click="submitFeedBack">提交</a>
      </div>
    </a-modal>
    <a-modal
      title="播放，仅剩一步"
      :visible="playLoginvisible"
      :footer="null"
      @cancel="handleCancel"
    >
      <!-- <p>亲爱的读者，此功能仅限馆内网络环境，建议您登录馆内Wi-Fi后使用</p> -->
      <p>亲爱的读者，请您登录读者证后使用</p>
      <div class="modal-btn">
        <a href="javascript:" class="cancel" @click="handleCancel">取消</a>
        <a :href="loginHref" class="confirm">去登录</a>
        <a :href="registerUrl"  class="info">去注册</a>
      </div>
    </a-modal>

    <a-modal
      title="收藏，仅剩一步"
      :visible="sc"
      @ok="handleOk"
      :footer="null"
      @cancel="schandleCancel"
    >
      <p>您还未登录，暂无收藏权限。 登录后即可收藏 ：)</p>
      <div class="modal-btn">
        <a href="javascript:" class="cancel" @click="schandleCancel">取消</a>
        <a :href="loginHref" class="confirm" @click="handleOk">去登录</a>
      </div>
    </a-modal>
  <a-modal
      title="该栏目暂无法播放"
      :visible="nolmplay"
      :footer="null"
      @cancel="nolmhandleCancel"
    >
      <p>亲爱的读者，栏目连播功能仅限馆内网络环境，建议您登录馆内Wi-Fi后使用</p>
      <div class="modal-btn">
        <a href="javascript:" class="confirm" @click="nolmhandleCancel"
          >知道了</a
        >
      </div>
    </a-modal>

    <a-modal
      title="该曲目暂无法播放"
      :visible="noqmplay"
      :footer="null"
      @cancel="noqmhandleCancel"
    >
      <p>亲爱的读者，本曲目仅限馆内网络环境播放，建议您登录馆内Wi-Fi后使用</p>
      <div class="modal-btn">
        <a href="javascript:" class="confirm" @click="noqmhandleCancel"
          >知道了</a
        >
      </div>
    </a-modal>

    <a-modal
      title="该唱片暂无法播放"
      :visible="nocpplay"
      :footer="null"
      @cancel="nocphandleCancel"
    >
      <p>亲爱的读者，本唱片仅限馆内网络环境播放，建议您登录馆内Wi-Fi后使用</p>
      <div class="modal-btn">
        <a href="javascript:" class="confirm" @click="nocphandleCancel"
          >知道了</a
        >
      </div>
    </a-modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { phonorecordSuggest,feedBackAdd,userIpInfo } from "@/api";
import { eventBus } from "@/util/eventBus";
export default {
  props: {
    showMobileSearch: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
       feedContent: '',//反馈弹框-富文本框内容
       feedTitle: '',//反馈弹框-富文本框内容
       feedPhone: '',//反馈弹框-富文本框内容
      loginHref: null,
      ip:'',
      txtTitleVal:0,
      txtContentVal:0,
      // isLogin:true,
      playLoginvisible: false,
      feedBackVisible:false,//反馈弹框是否可见
      sc: false,
      nolmplay: false,//首页栏目是否可播放
      noqmplay: false,
      nocpplay: false,
      searchHover: false,
      showSearchHelp: false,
      keyword: this.$route.query.keyword || "",
      hasAdvance: false,//高级检索标记
      avatar: require("./../../public/img/demo/image.png"),
      showUserMenu: false,
      showMobileSlideNav: false,
      showMobileSlideNavCurrent: "乐人",
      showMobileSlideUser: false,
      routeName: this.$route.name, // 模块名,
      yrList: [],
      cpList: [],
      qmList: [],
      jgList: [],
      // registerUrl:"https://ecard.library.sh.cn/?user_type=D0&redirect_uri=https%3A%2F%2Fdhapi.library.sh.cn%2Fmanagement%2Fwebapi%2Fcenofmagent%2Ftoken%2Flocpage%3FsystemId%3D18%26durl%3Dhttps%3A%2F%2Fcp.library.sh.cn%2F"
    registerUrl:"https://dhapi.library.sh.cn/management/webapi/cenofmagent/token/register?systemId=18&redirectUrl=https://cp.library.sh.cn"
   
   };
  },
  computed: {
    ...mapGetters({
      userInfo: "getUserInfo", // getToDo 不是字符串，对应的是getter里面的一个方法名字 然后将这个方法名字重新取一个别名 todosALise
    }),
    isLogin() {
      return this.userInfo.userName;
    },
  },
  mounted() {
    this.InitMobileNavStatus();//手机端：导航控制登录组件、乐人机构组件互不干扰且点击其他区域关闭导航
    this.loginHref = this.GLOBAL.BASE_LOGIN_URL + window.location.href;
    this.InitMobile();
    this.InitBaseIp();//初始化访客IP信息
    // this.isLogin = localStorage.getItem('token') ? true : false;
    var reg = new RegExp("(^|&)" + "token" + "=([^&]*)(&|$)", "i");
    const tokenstr = window.location.search.substr(1).match(reg);
    if (!localStorage.getItem("token")) {
      if (tokenstr) {
        localStorage.setItem("token", unescape(tokenstr[2]));
        //重新加载画面，加载用户数据，已在其他地方解决，所以注释
        //  location.reload();
      }
    } else {
      // this.isLogin = true;
    }
    eventBus.$on("clearAdvance", () => {
      this.hasAdvance = false;
    });
  },
  methods: {
    async InitBaseIp() { // 获取用户IP信息 chenss 20220831
      if(this.GLOBAL.BASE_IP_INFO==''){
        const res = await userIpInfo();
        const result = res;
        this.GLOBAL.BASE_IP_INFO=result.data;
      }
    //  alert(this.GLOBAL.BASE_IP_INFO.ipIsInner+'----------'+this.GLOBAL.BASE_IP_INFO.ip);
    },
    // 获取客户端IP
getUserIP(onNewIP) {
  const MyPeerConnection = window.RTCPeerConnection || window.mozRTCPeerConnection || window.webkitRTCPeerConnection
  const pc = new MyPeerConnection({
    iceServers: []
  })
  const noop = () => {
  }
  const localIPs = {}
  const ipRegex = /([0-9]{1,3}(\.[0-9]{1,3}){3}|[a-f0-9]{1,4}(:[a-f0-9]{1,4}){7})/g
  const iterateIP = (ip) => {
    if (!localIPs[ip]) onNewIP(ip)
    localIPs[ip] = true
  }
  pc.createDataChannel('')
  pc.createOffer().then((sdp) => {
    sdp.sdp.split('\n').forEach(function(line) {
      if (line.indexOf('candidate') < 0) return
      line.match(ipRegex).forEach(iterateIP)
    })
    pc.setLocalDescription(sdp, noop, noop)
  }).catch((reason) => {
  })
  pc.onicecandidate = (ice) => {
    if (!ice || !ice.candidate || !ice.candidate.candidate || !ice.candidate.candidate.match(ipRegex)) return
    ice.candidate.candidate.match(ipRegex).forEach(iterateIP)
  }
},
    cpnclick(isFav) {
      this.$message.open({
        content: isFav ? "已收藏" : "已取消收藏",
        icon: (
          <img
            style="width:14px;height:14px;margin-right:5px"
            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAQCAYAAAAbBi9cAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAEUSURBVHgBpZFNbsIwEIVnvEBZplL/dqUnqHqD3qDpBsyuPUF7g6Q3oCeougOvygm4AtwgOyQiBFsEzDC2CAo/gZA8yYn9xv409kPIaBoE/sLzAiR6UIgzGb2rTie2tZHW9RrzKzH7BDCsKTVIa1aYTsat1pciChnAh121ZROK/5k1xYuXzD/3xrS3oLHW78j8CyUkHb7dGfOv7EIxh1BSAnANYKL1CzD3oYLmRM9K7l6HivIQnxSsVgOoKGaO3WMnzeYUDtMqBpH0brvdR/fYktgHlJQEFbm//Vzb+DbGZe1wJGf/XDNZf9JohIQYFYXcGPOdLnG/Xgi2BzkKOgs7AskF5cJyICdBB7ATkEKysETGuX1rfziAH44aflAAAAAASUVORK5CYII="
          />
        ),
      });
    },
     descInput(txtId){//文本框动态数字
      if(txtId==1){ this.txtTitleVal= this.feedTitle.length;}
      if(txtId==2){ this.txtContentVal = this.feedContent.length;}
// console.log(txtId)
    },
    InitMobileNavStatus(){
      let _this = this;
      document.addEventListener('click', function (e) {
　　　　// 下面这句代码是获取 点击的区域是否包含你的菜单，如果包含，说明点击的是菜单以外，不包含则为菜单以内
      let flag = e.target.contains(document.getElementsByClassName('hover-user')[0])
      let flagNav = e.target.contains(document.getElementsByClassName('hover-nav')[0])
      if(!flag) {  _this.showMobileSlideUser = false}
      if(!flagNav) { _this.showMobileSlideNav = false}
      })
    },
    //点击更多跳转搜索
    moreClick(item) {
      this.$router.push({
        path: "/search",
        query: {
          keyword: this.keyword,
        },
      });
      let res = [];
      this.showSearchHelp = false;
      setTimeout(() => {
        eventBus.$emit("advanceSearch", res, item);
        eventBus.$emit("resSetForm", item);
      }, 10);
    },
    InitMobile() {
      this.showMobileSlideNavCurrent =
        this.$route.path === "/musician-depot" ? "乐人" : "机构";
    },
    handleCancel() {
      this.playLoginvisible = false;

    },

    schandleCancel() {
      this.sc = false;
    },
    noqmhandleCancel() {
      this.noqmplay = false;
    },
     nolmhandleCancel() {
      this.nolmplay = false;
    },
    nocphandleCancel() {
      this.nocpplay = false;
    },
    handleOk() {},
    showTk(t) {
      //console.log(t);
      //未登录播放
      if (t == 1) {
        this.playLoginvisible = true;
      }
      //未登录收藏
      if (t == 2) {
        this.sc = true;
      }
      //无唱片播放
      if (t == 3) {
        this.nocpplay = true;
      }
      //无曲目播放
      if (t == 4) {
        this.noqmplay = true;
      }
       //无栏目播放
      if (t == 5) {
        this.nolmplay = true;
      }
    },
    goSearch() {
      this.showSearchHelp = false;
      if (this.$route.name != "search") {
        this.$router.push({
          name: "search",
          query: {
            keyword: this.keyword,
          },
        });
      } else {
        this.$emit("changeKey", this.keyword ? this.keyword : "");
      }
      let item = "searchRecord";
      let res = [];
      setTimeout(() => {
        eventBus.$emit("advanceSearch", res, item);
        eventBus.$emit("resSetForm", item);
      }, 200);
    },
    logout() {
      localStorage.removeItem("token");
      window.location.href = "/";
    },
    hoverHandle() {
      this.searchHover = true;
    },
    advanced() {
      this.showSearchHelp = false;
      eventBus.$emit("advanceChange", true);
    },
    blurHandle() {
      this.searchHover = false;
    },
    clearKeyWord() {
      this.keyword = "";
      this.searchHover = false;
      this.showSearchHelp = false;
    },
    async changeHandle(e) {
      this.showSearchHelp = false;
      if (e.target.value !== "") {
        if (e.keyCode == 13) {
          this.goSearch();
          this.showSearchHelp = true;
          return;
        }
        const res = await phonorecordSuggest({ q: e.target.value });
        const data = res.data.datas;

        this.cpList = data.phonorecord;
        this.qmList = data.music;
        this.jgList = data.organization;

        this.yrList = data.person;
        //当有检索结果时，弹出备选框
        if( this.cpList.length>0 || this.qmList.length>0 ||  this.jgList.length>0 || this.yrList.length>0)
        this.showSearchHelp = true;
      }
    },
    onRouteLink() {
      // 跳转连接
      if (
        this.routeName.indexOf("record") != -1 ||
        this.routeName.indexOf("Home") != -1
      )
        return "/search/record";
      if (this.routeName.indexOf("song") != -1) return "/search/song";
      if (this.routeName.indexOf("musician") != -1) return "/search/musician";
      if (this.routeName.indexOf("company") != -1) return "/search/company";
    },
    loginout() {
      localStorage.removeItem("token");
      this.$store.commit("setUserInfo", {});
      // this.isLogin = false;
      this.$router.push({ path: "/" });
    },
    loginout1() {
      localStorage.removeItem("token");
      this.$store.commit("setUserInfo", {});
      // this.isLogin = false;
      window.location.href = "/";
    },
     adminLogin() {
      window.open('http://scccms.library.sh.cn');
    },
    clearFeedBack(){//清空反馈信息
      this.feedPhone='';
      this.feedTitle='';
      this.feedContent='';
    },
   openFeedBack() {//打开反馈弹框
        this.feedBackVisible=true;
        return;
    },
   closeFeedBack() {//反馈弹框关闭
      this.feedBackVisible=false;
      this.clearFeedBack();
      return;
    },
  async submitFeedBack(){//提交反馈内容
    var parms={
      title:this.feedTitle,
      content:this.feedContent,
      systemId:18
      };
      if(this.feedTitle==''){
         this.$message.error("反馈标题不能为空");
         return;
      }
      if(this.feedTitle.length<5){
         this.$message.error("反馈标题不能少于5个字符");
         return;
      }
      if(this.feedContent==''){
         this.$message.error("反馈内容不能为空");
         return;
      }
       if(this.feedContent.length<10){
         this.$message.error("反馈内容不能少于10个字符");
         return;
      }
    //调用反馈插入接口，进行反馈
    const res = await feedBackAdd(parms);
   if(res.data.result==0){
      this.$message.success("反馈成功");//反馈成功
      this.closeFeedBack();//关闭弹框
   }
   else{
      this.$message.error(res.data.message);//反馈失败
   }
     return;
  }
  },
  watch: {
    $route() {
      this.routeName = this.$route.name;
    },
  },
};
</script>
/*反馈弹框样式 */
<style type="css/text" >
.ipt-box{
        display: flex;
        flex-wrap: wrap;
      }
.ipt-box .ipt{
          display: flex;
          align-items: center;
          justify-content: space-between;
          width: 100%;
          padding: 0 0px;
          margin-bottom: 15px;

        }
.ipt-box .ipt .lb{
            width: 100px;
            flex-shrink: 0;
            text-align: right;
            margin-right: 10px;
            line-height: 1.1;
          }
.ipt-box .ipt .inputNum1{
  position: absolute;
  right: 30px;
  top: 95px;
  color: #d9d9d9;
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  -khtml-user-select: none;
  user-select: none;
}
.ipt-box .ipt .inputNum2{
  position: absolute;
  right: 30px;
  bottom: 90px;
  color: #d9d9d9;
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  -khtml-user-select: none;
  user-select: none;
}
::-webkit-scrollbar {
          width: 8px;
          height: 8px;
          background: none;
        }
::-webkit-scrollbar-thumb
        {
          border-radius: 4px;
          background-color: #BDBDBD;
        }
</style>
